<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>

export default {
    components: {  },
    data() {
        return {
            commonTopData: {
                pageName: "newsRelease",
                commonleftbtn: [],
            },
            form: {
                files: [],
                versionName: '',
                versionCode: ''
            }
        };
    },
    methods: {
        init() {
            this.getDownloadUrl()
        },
        async getDownloadUrl() {
            let data = await this.api.getDownloadUrl({
                access_token: localStorage.getItem("access_token")
            })
            if(data) {
                let { lock_screen_file_name: name, lock_screen_kit_size: size, lock_screen_kit_link: url, version_name, version_code} = data
                this.form = {
                    files: [{ name, size, url }],
                    versionName: version_name,
                    versionCode: version_code
                }
            }
        },
        async setLockScreenConfig() {
            let { files, versionName, versionCode } = this.form
            let { size, url, name } = files[0] || {}

            if(versionName === '' || versionCode === '') {
                this.$message.error('请补充完信息')
                return
            }else if(!url) {
                this.$message.error('请上传工具包')
                return
            }
            
            let data = await this.api.setLockScreenConfig({
                lock_screen_kit_link: url,
                lock_screen_kit_size: size,
                lock_screen_file_name: name,
                access_token: localStorage.getItem("access_token"),
                version_name: versionName,
                version_code: versionCode
            })
            if(data) {
                this.$message({
                    type: 'success',
                    message: '锁屏包更新成功'
                })
            }
        },
        fileChange(files) {
            this.form.files = files.slice(-1)
        },
        save() {
            this.setLockScreenConfig()
        }
    },
    created() {
        this.init();
    },
};
</script>
